import Spinner from "./icons/Spinner";

const SuspenseFallback = () => (
  <div className="flex items-center justify-center size-full text-white fixed top-0 left-0 bg-slate-900/60 z-[999]">
    <Spinner width={300} />
  </div>
);

export default SuspenseFallback;
